const StandartDynamicPageContainer = () =>
  import('@/views/containers/StandartDynamicPageContainer/StandartDynamicPageContainer.vue');
const CatalogRedesignView = () => import('@/views/Catalog/ProductsRedesign/ProductsRedesign.vue');
const CatalogView = () => import('@/views/Catalog/Products/Products.vue');
const ProductDetailRedesignView = () =>
  import('@/components/products/catalog/ProductDetailRedesign.vue');
const ProductDetailView = () => import('@/components/products/catalog/ProductDetail.vue');

export const getBasicRoutes = (configDataFromServer) => {
  return {
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        name: 'inicio',
        component: StandartDynamicPageContainer,
        props: {
          idSubSection: 5,
          configData: configDataFromServer,
        },
      },
      {
        path: '/nosotros',
        name: 'nosotros',
        component: () => import('./views/About.vue'),
      },
      {
        path: '/catalogos',
        name: 'catalogos',
        component: () => import('./views/Publications.vue'),
      },
      {
        path: '/reclamo',
        name: 'reclamo',
        component: () => import('./views/ClaimsBook.vue'),
        props: {
          configData: configDataFromServer,
        },
      },
      {
        path: '/catalogos-ofertas/:cate?/:subcate?',
        name: 'catalogos-ofertas',
        component: () => import('./views/Offers.vue'),
      },
      {
        path: '/404',
        name: '404',
        component: () => import('./views/404.vue'),
      },
      {
        path: '/Timeout',
        name: 'Timeout',
        component: () => import('./views/Timeout.vue'),
      },
      {
        path: '*',
        component: () => import('./views/404.vue'),
      },
    ],
  };
};

export const getAccountRoutes = (configDataFromServer) => {
  return [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue'),
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/registrar',
      name: 'registrar',
      props: true,
      component: () => import('./views/Register.vue'),
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/reset-pass',
      name: 'reset-pass',
      component: () => import('./views/ResetPass.vue'),
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/enable-client/:email',
      name: 'enable-client',
      component: () => import('./views/EnableClient.vue'),
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/perfil',
      name: 'perfil',
      component: () => import('./views/Profile.vue'),
      props: {
        configData: configDataFromServer,
      },
    },
  ];
};

export const getEcommerceRoutes = (configDataFromServer) => {
  return [
    {
      path: '/productos/:crit?/:page?/:cate?/:subcate?/:caliber?/:brand?/:query?',
      name: 'productos',
      
      component: configDataFromServer.designFlags.isRedesignCatalog
        ? CatalogRedesignView
        : CatalogView,
        
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/producto/:id',
      name: 'detalle-productos',
      
      component: configDataFromServer.designFlags.isRedesignCatalog
        ? ProductDetailRedesignView
        : ProductDetailView,
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/carrito',
      name: 'carrito',
      component: () =>
        import('./components/products/cart/CartProductsStepOne/CartProductsStepOne.vue'),
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: '/datos-compra',
      name: 'datos-compra',
      component: () =>
        import('./components/products/cart/CartProductsStepTwo/CartProductsStepTwo.vue'),
      beforeEnter: (to, from, next) => {
        next();
      },
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/resumen',
      name: 'resumen',
      component: () =>
        import('./components/products/cart/CartProductsStepThree/CartProductsStepThree.vue'),
      beforeEnter: (to, from, next) => {
        next();
      },
      props: {
        configData: configDataFromServer,
      },
    },
    {
      path: '/visa-final/:token',
      name: 'visa-final',
      component: () =>
        import('./components/products/cart/CartProductsStepThree/CartProductsStepThree.vue'),
      props: {
        visaFinalization: true,
        configData: configDataFromServer,
      },
      beforeEnter: (to, from, next) => {
        next();
      },
    },
    {
      path: '/pedidos',
      name: 'pedidos',
      component: () => import('./views/Orders.vue'),
    },
    {
      path: '/seguimiento/:id?',
      name: 'seguimiento',
      component: () => import('./views/TrackingView.vue'),
    },
    {
      path: '/confirmacion',
      name: 'confirmacion',
      component: () => import('./views/Confirmation.vue'),
    },
  ];
};

export const getDynamicRoutes = (seccionList, configDataFromServer) => {
  let dynamicRoutes = [];
  seccionList.forEach(function(section) {
    const idSection = section.cod_section;
    if (!(idSection == 2)) {
      let idSubSection = section.sub_sections[0].cod_sub_section;
      var dynamicRoute = {
        path:
          idSection === 4 || idSection === 8
            ? '/' + section.url_es + '/:id?'
            : '/' + section.url_es,
        name: section.url_es,
        component: StandartDynamicPageContainer,
        props: {
          idSubSection: idSubSection,
          configData: configDataFromServer,
        },
      };
      dynamicRoutes.push(dynamicRoute);
    }
  });
  return dynamicRoutes;
};
